<script>
    import { getContext, onMount } from "svelte";
    import { uuid,isEmptyObject } from "../../utils";
    const clsPrefix = "sui-tabs-tabpanel";
    export let title = "";
    export let active = false;
    export let disabled = false;
    const id = uuid();
    const ctx = getContext("Tabs");
    let unsubscribe;
    let activeEl = {};

    onMount(() => {
        if (ctx) {
            ctx.add({ id, active, title, disabled });
            unsubscribe = ctx.items.subscribe((value) => {
                activeEl = value.filter((el) => el.active)[0];
            });
        }
        return () => {
            unsubscribe && unsubscribe();
        };
    });
</script>

{#if activeEl.id === id && !isEmptyObject($$slots)}
    <div
        class={clsPrefix}
        id={`tabpanel-${id}`}
        tabindex="0"
        role="tabpanel"
        aria-labelledby={`tab-${id}`}
    >
        <slot />
    </div>
{/if}

<style lang="less">
    @import "./tabs.less";
</style>
